const topicItems = [
  { tag: '港片情怀', hot: true, count: '3.2万讨论' },
  { tag: '漫威宇宙', hot: true, count: '5.8万讨论' },
  { tag: '国产好片', hot: true, count: '4.1万讨论' },
  { tag: '恐怖片推荐', hot: false, count: '1.9万讨论' },
  { tag: '周末观影', hot: true, count: '2.7万讨论' },
  { tag: '奥斯卡佳作', hot: false, count: '3.5万讨论' },
  { tag: '韩国电影', hot: true, count: '2.3万讨论' },
  { tag: '日系治愈', hot: false, count: '1.6万讨论' },
  { tag: '独立电影', hot: false, count: '8.5千讨论' },
  { tag: '网飞热门', hot: true, count: '6.2万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">影迷们正在热烈讨论的电影话题，加入对话分享你的观点</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <span
              key={item.tag}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200 hover:border-accent-300 hover:bg-accent-50 transition-colors cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">#{item.tag}</span>
              {item.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-primary-500"></i>
                </span>
              )}
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}